import { Avatar } from 'antd';
import styled from 'styled-components';

export const StyledAvatar = styled(Avatar)`
  .avatar-user-placeholder-icon {
    color: ${({ theme }) => theme.colors.gray10};
  }
`;
